import { React, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { logOutUser } from "../../storeSlices/userSlice";
import { useNavigate } from "react-router-dom";
import { getTruckDetails } from "../../storeSlices/dataSlice";
import { getMyProfile, getDriverDetails } from "../../storeSlices/dataSlice";
import { getClientDetails } from "../../storeSlices/dataSlice";
import { getEwayBillDetails } from "../../storeSlices/dataSlice";
import { setStatusAuth } from "../../storeSlices/dataSlice";
import { AppBar, Box, Toolbar, Button, CssBaseline } from "@mui/material";
//import { LoadingButton } from "@mui/lab";

const drawerWidth = 240;

const classes = {
  dashboardHeaderActions: {
    width: "100%",
    gap: "1rem",
    display: "flex",
    justifyContent: "flex-end",
    "& button.MuiButton-root": {
      textTransform: "capitalize",
    },
  },
};

export default function DashBoardHeader() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTruckDetails());
    dispatch(getDriverDetails());
    dispatch(getClientDetails());
    dispatch(getEwayBillDetails());
    dispatch(getMyProfile());
  });
  const navigate = useNavigate();

  const navigateToEwayBillAuthentication = () =>
    navigate("/dashbaord/chalan/ewaybillauth");

  const handleLogOut = () => {
    setLoading(true);
    dispatch(setStatusAuth(false));
    dispatch(logOutUser());
    navigate("/");
  };

  return (
    <Box className="dashboardHeader" component="header">
      <CssBaseline />
      <AppBar
        position="fixed"
        color="inherit"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        component="div"
      >
        <Toolbar>
          <Box className="dashboardActions" sx={classes.dashboardHeaderActions}>
            <Button
              color="inherit"
              onClick={navigateToEwayBillAuthentication}
              size="large"
            >
              EwayBill Authentication
            </Button>
            <Button
              color="inherit"
              onClick={() => {
                navigate("/dashbaord/myprofile");
              }}
              size="large"
            >
              Profile
            </Button>
            <Button
              color="inherit"
              loading={loading}
              onClick={handleLogOut}
              size="large"
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
